import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'ramda/src/isEmpty';
import slice from 'ramda/src/slice';
import Button from '@components/@core/AnimatedButton';
import Pagination from '@components/@core/Pagination';
import EmptyForum from './EmptyForum';
import ForumItem from './ForumItem';

const VendorSearchForums = ({ data, type, onPage, onSeeAll }) => {
    const navigate = useNavigate();
    const forumList = data?.data ?? [];
    const forums = type === 'sub' ? slice(0, 2, forumList) : forumList;

    const handleOpenDetail = (e) => () => {
        navigate(`/community/forums/${e.id}/${e.categories && e.categories[0].id}`);
    };

    return (
        <div className="vendor-search-forums">
            <div className="d-h-between">
                <div className="d-h-start">
                    <p className="dsl-b18 bold me-2">Forums</p>
                    <p className="dsl-p12">{`(${data?.total ?? forumList.length})`}</p>
                </div>
            </div>
            {isEmpty(forums) ? (
                <EmptyForum />
            ) : (
                <>
                    {forums.map((forum) => {
                        const { id, name, comments, categories, stats } = forum;
                        const authorName = `${comments[0]?.user?.first_name} ${comments[0]?.user?.last_name}`;
                        const categoryName = categories[0].name;
                        return (
                            <ForumItem
                                key={`forum-${id}`}
                                name={name}
                                avatar={comments[0]?.author_avatar}
                                creator={authorName}
                                forumType={categoryName}
                                stats={stats}
                                comments={comments}
                                type={type === 'sub' ? 'simple' : 'detail'}
                                onClick={handleOpenDetail(forum)}
                            />
                        );
                    })}
                    {type === 'sub' ? (
                        <div className="d-h-end">
                            <Button type="link" name="SEE ALL" onClick={onSeeAll} />
                        </div>
                    ) : (
                        <Pagination current={data?.current_page ?? 1} pers={[]} total={data?.last_page ?? 0} onChange={onPage} />
                    )}
                </>
            )}
        </div>
    );
};

VendorSearchForums.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.array,
    }),
    type: PropTypes.oneOf(['sub', 'full']),
    onSeeAll: PropTypes.func,
    onPage: PropTypes.func,
};

VendorSearchForums.defaultProps = {
    data: { data: [] },
    type: 'sub',
    onSeeAll: () => {},
    onPage: () => {},
};

export default memo(VendorSearchForums);
